import React from "react";
import { TouchableOpacity, View, Text, Dimensions } from "react-native";
import FastImage from "react-native-fast-image";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import * as Animatable from "react-native-animatable";
import theme from "app/Theme/Theme";

const { width, height } = Dimensions.get("window");

const isAvatarPicture = picture => {
  return picture.indexOf("AVATAR") > -1;
};

const UserCard = ({
  onPressResult,
  _id,
  picture,
  firstName,
  lastName,
  jobDescription,
  animation,
}) => {
  return (
    <Animatable.View animation={animation} useNativeDriver>
      <TouchableOpacity
        onPress={onPressResult(_id)}
        style={[
          styles.card,
          isAvatarPicture(picture) && {
            elevation: 0,
            shadowRadius: 0,
            shadowOffset: {},
          },
        ]}
      >
        <FastImage
          resizeMode="cover"
          style={{
            borderRadius: 8,
            height: (width * 1.33) / 2,
            width: (width - 30) / 2,
          }}
          source={{ uri: picture }}
        />
        <View style={styles.textView}>
          <Text style={styles.name} numberOfLines={1}>
            {`${firstName} ${lastName}`}
          </Text>
          {!!jobDescription && (
            <Text style={styles.jobDescription} numberOfLines={1}>
              {`${jobDescription}`}
            </Text>
          )}
        </View>
      </TouchableOpacity>
    </Animatable.View>
  );
};

const styles = {
  card: {
    flexDirection: "row",
    alignItems: "center",
    shadowColor: "#000000",
    elevation: 2,
    zIndex: 1,
    marginBottom: 10,
    height: (width * 1.33) / 2,
    width: (width - 30) / 2,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowRadius: 6,
    shadowOpacity: 0.3,
    borderRadius: 8,
  },
  name: {
    maxWidth: (width - 30) / 2 - 10,
    color: theme.colors["neutral.white"],
    fontSize: wp("4%"),
    marginRight: 5,
    fontWeight: "bold",
  },
  jobDescription: {
    maxWidth: (width - 30) / 2 - 10,
    color: theme.colors["neutral.white"],
    fontSize: wp("3.5%"),
    marginRight: 5,
  },
  textView: {
    padding: 5,
    borderRadius: 8,
    flexDirection: "column",
    position: "absolute",
    bottom: 0,
    left: 0,
    backgroundColor: theme.colors["neutral.900"],
  },
};

export default UserCard;
